import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import { marketingClient } from "@trueskin-web/apis"
import { Button } from "@trueskin-web/components"
import { Routes } from "@trueskin-web/translations"

import Card from "./card"

const ChoosePlan = () => {
  const handleClick = () => {
    marketingClient.trackEvent({
      name: marketingClient.EVENT_TYPES_ENUM
        .NAVIGATION_PAGE_PLAN_SELECTION_CTA_CLICKED,
    })

    navigate(Routes.App.Start.ChoosePlan.url)
  }

  return (
    <Card
      title={
        <div
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div sx={{ maxWidth: "80%" }}>Weiter zu Deinem Behandlungsplan</div>
          <StaticImage
            src="./images/box_2x.png"
            alt=""
            width={75}
            sx={{ flexShrink: 0 }}
          />
        </div>
      }
      status="current"
    >
      <div sx={{ mb: 3 }}>
        Erhalte monatliche Check-ins, Anpassungen der Formel und 24/7 Zugang zu
        Deinem Arzt/Deiner Ärztin
      </div>
      <Button
        rounded
        isFullWidth
        onClick={handleClick}
        sx={{ mt: 1 }}
        data-testid="navigation-to-plan-selection-btn"
      >
        Wähle Deinen Plan
      </Button>
    </Card>
  )
}

export default ChoosePlan
